import React from "react";

function TitleValue({ title, value }) {
  return (
    <div className="text-left">
      <p className="bold mb-0 text-small">{title}</p>
      <p className="text-small">{value}</p>
    </div>
  );
}

export default TitleValue;
